import styled from "styled-components";
import { Box, Stack, ButtonBase, Typography } from "@mui/material";

export const InfoText = styled(Typography)`
  && {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 30px;
    letter-spacing: 0.05em;
    color: #000000;
    width: 800px;
    margin: auto;
  }
`;

export const Title = styled(Typography)`
  && {
    font-family: "Noto Serif";
    font-style: normal;
    font-weight: 600;
    font-size: 32px;
    line-height: 44px;
    letter-spacing: 0.05em;
    color: #229fa4;
    padding-top: 65px;
    padding-bottom: 10px;
    border-bottom: 1px solid #229fa4;
  }
`;

export const Details = styled(Typography)`
  && {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 32px;
    letter-spacing: 0.05em;
    color: #000000;
  }
`;

export const FormContainer = styled(Stack)`
  && {
    height: 525px;
    background: #ffffff;
    box-shadow: -2px 2px 2px rgba(0, 0, 0, 0.25);
    border-radius: 15px;
    padding-top: 20px;
    padding-bottom: 20px;
  }
`;

export const FormTitle = styled(Typography)`
  && {
    font-family: "Noto Serif";
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 27px;
    text-align: center;
    letter-spacing: 0.05em;
    color: #000000;
    margin-bottom: 12px;
  }
`;

export const InputField = styled(Box)`
  && {
    height: ${(props) => props.txtArea || "50px"};
    background: rgba(235, 235, 235, 0.75);
    border-radius: 10px;
    border: 0px;
    width: 75%;
    padding-left: 25px;
    padding-right: 25px;

    font-family: "Montserrat";
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 18px;
    letter-spacing: 0.05em;
    color: #000000;
  }
`;

export const SumbitButton = styled(ButtonBase)`
  && {
    width: 175px;
    height: 50px;
    background: #f2753b;
    box-shadow: -2px 2px 2px rgba(0, 0, 0, 0.25);
    border-radius: 5px;
    text-transform: capitalize;
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.05em;
    color: #ffffff;
    margin-top: 30px;
  }
`;
